import { Loader } from "@/components/generic/loader.component";

export function LoadingFallback() {
  return (
    <div className="flex justify-center items-center w-full h-full">
      <Loader />
    </div>
  );
}
